import React from "react";
import "./HomePage.scss";
import HeroHome from "./hero/HeroHome";
import LogoMarquee from "./logoMarquee/LogoMarquee";
import WhyChooseUs from "./whyChooseUs/WhyChooseUs";
import KeyFeatures from "./keyFeatures/KeyFeatures";
import AnalyticsHub from "./analyticsHub/AnalyticsHub";
import ProductionHouse from "./productionHouse/ProductionHouse";
import PricingPlans from "../subscription/PricingPlans";
import Testimonials from "./testimonials/Testimonials";
import BuildTeam from "./buildTeam/BuildTeam";
import FAQ from "./faq/FAQ";

const HomePage: React.FC = () => {
    return (
        <div className="homepage-wrapper">


            <div className="homepage-no-gap-group">
                <HeroHome />
                <LogoMarquee />
                <WhyChooseUs />

            </div>
            <KeyFeatures />
            <AnalyticsHub />
            <ProductionHouse />
            <PricingPlans />
            <Testimonials />
            <BuildTeam />
            <FAQ />
        </div>
    );
};

export default HomePage;
